import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "new-game-view d-flex" }
const _hoisted_2 = { class: "pa-6 new-game-form" }
const _hoisted_3 = { class: "d-flex form-row class-setting" }
const _hoisted_4 = { class: "d-flex form-row team-file-setting" }
const _hoisted_5 = { class: "d-flex form-row team-total-setting" }
const _hoisted_6 = { class: "d-flex form-row team-num-setting" }
const _hoisted_7 = { class: "d-flex form-row team-num-setting" }
const _hoisted_8 = { class: "ml-6 mt-4" }

import {onMounted, ref, watch} from "vue";
import {ApiMap} from "@/api/type";
import {useApi} from "@/api/handler";
import {classes, game, team} from "@/api";
import DownloadBox from "@/components/game/DownloadBox.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import store from "@/store";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'NewGame',
  props: {
    cid: {}
  },
  emits: ['updateTeamList'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit
const routers = useRouter()

const classList = ref<ApiMap['/class/list']['resp'] | null>(null)
const selectedClass = ref<number | null>(null)
const showOverlay = ref<boolean>(false)
const showDialog = ref<boolean>(false)
const teamFile = ref<File | null>(null)
const teamNum = ref<number | null>(null)
const studentNum = ref<number | null>(null)
const teamBaseNum = ref<number | null>(null)
const buttonLoading = ref<boolean>(false)
const showGameStart = ref<boolean>(false)
const gameId = ref<number | null>(null)

onMounted(() => {
  useClassList()
})

watch(() => props.cid, (newCid) => {
  if (newCid) selectedClass.value = newCid
}, {immediate: true})

function handleDownload(num: number) {
  useDownloadTeamFile(num)
  showOverlay.value = false
}

function handleGameStart () {
  if (!gameId.value) {
    store.dispatch('snackBarModule/showError', '游戏数据有误，请正确填写')
    return
  } else {
    routers.push({path: '/board', query: {id: gameId.value}})
  }
}

function handleUpload () {
  if (teamFile.value && teamNum.value && studentNum.value && teamBaseNum.value) {
    buttonLoading.value = true
    useUploadTeam()
  } else {
    store.dispatch('snackBarModule/showError', '请正确填写数据')
  }
}

const useClassList = () => {
  useApi({
    api: classes.ClassList(0, 50, ''),
    onSuccess: resp => {
      classList.value = resp.data as ApiMap['/class/list']['resp']
    }
  })
}

const useDownloadTeamFile = (num: number) => {
  team.DownloadTeamFile(num).then(resp => {
      const url = URL.createObjectURL(resp.data as Blob)
      const a = document.createElement('a')
      a.href = url
      a.download = '分组文件模板.xlsx'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
  })
}

const useUploadTeam = () => {
  if (!teamFile.value || !teamNum.value || !studentNum.value || !teamBaseNum.value) return
    useApi({
      api: game.UploadTeam(teamFile.value, teamNum.value, studentNum.value, teamBaseNum.value, props.cid ?? 0 ),
      onSuccess: resp => {
        buttonLoading.value = false
        gameId.value = (resp.data as ApiMap['/game/upload']['resp']).gameId
        emits('updateTeamList', gameId.value)
        showGameStart.value = true
      },
      Finally: () => {showDialog.value = false},
      tip: '上传成功'
    })
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-h5 font-weight-bold text-indigo-lighten-2 ml-6 mb-8" }, "新增游戏设置", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "px-8 mt-1 text-label" }, "班级", -1)),
        _createVNode(_component_v_select, {
          modelValue: selectedClass.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedClass).value = $event)),
          items: classList.value ? classList.value.list : [],
          density: "compact",
          "item-title": "classCode",
          "item-value": "id",
          placeholder: "请选择班级",
          variant: "outlined"
        }, null, 8, ["modelValue", "items"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "px-8 mt-1 text-label" }, "分组情况文件", -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_v_file_input, {
            min: 0,
            variant: "outlined",
            modelValue: teamFile.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((teamFile).value = $event)),
            label: "点击上传 Excel",
            "prepend-icon": "",
            density: "compact",
            width: "320",
            "show-size": ""
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_tooltip, {
                text: "下载模板文件",
                location: "bottom"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_icon, _mergeProps(props, {
                    icon: "mdi-download",
                    style: {"cursor":"pointer"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showOverlay.value = true))
                  }), null, 16)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "px-8 mt-1 text-label" }, "小组数量", -1)),
        _createVNode(_component_v_number_input, {
          min: 0,
          modelValue: teamNum.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((teamNum).value = $event)),
          density: "compact",
          placeholder: "请输入小组数量",
          variant: "outlined"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "px-8 mt-1 text-label" }, "学生总数", -1)),
        _createVNode(_component_v_number_input, {
          min: 0,
          modelValue: studentNum.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((studentNum).value = $event)),
          density: "compact",
          placeholder: "请输入学生总数",
          variant: "outlined"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "px-8 mt-1 text-label" }, "每组基准数", -1)),
        _createVNode(_component_v_number_input, {
          min: 0,
          modelValue: teamBaseNum.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((teamBaseNum).value = $event)),
          density: "compact",
          placeholder: "请输入基准数",
          variant: "outlined"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_v_btn, {
          block: "",
          color: "blue-lighten-1",
          height: "40px",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (showDialog.value = true))
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode("提交")
          ])),
          _: 1,
          __: [18]
        }),
        (showGameStart.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              block: "",
              color: "red-lighten-2",
              height: "40px",
              class: "mt-6",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (showDialog.value = true))
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode("确认无误？点此开始游戏")
              ])),
              _: 1,
              __: [19]
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_v_overlay, {
      modelValue: showOverlay.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showOverlay).value = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(DownloadBox, {
          onDownload: handleDownload,
          onCancel: _cache[8] || (_cache[8] = ($event: any) => (showOverlay.value = false))
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showDialog).value = $event)),
      width: "auto"
    }, {
      default: _withCtx(() => [
        _cache[21] || (_cache[21] = _createTextVNode("> ")),
        (!showGameStart.value)
          ? (_openBlock(), _createBlock(ConfirmDialog, {
              key: 0,
              title: "确认提交",
              text: "请再次检查Excel表格中学生是否和班级学生匹配",
              loading: buttonLoading.value,
              onConfirm: handleUpload,
              onCancel: _cache[10] || (_cache[10] = ($event: any) => (showDialog.value = false))
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true),
        (showGameStart.value)
          ? (_openBlock(), _createBlock(ConfirmDialog, {
              key: 1,
              title: "确认开始游戏",
              text: "请再次检查学生分组情况是否正确，一旦开始游戏将无法更改分组",
              onConfirm: handleGameStart,
              onCancel: _cache[11] || (_cache[11] = ($event: any) => (showDialog.value = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1,
      __: [21]
    }, 8, ["modelValue"])
  ]))
}
}

})